import { CbColorFontBase, CbColorFontInteractiveBase } from '@coolblue-development/design-tokens';
import styled from '@emotion/styled';
export const LogoLink = styled.a `
  color: ${CbColorFontBase};
  text-decoration: none;

  :hover {
    color: ${CbColorFontInteractiveBase};
  }
`;
export const ScreenReaderOnly = styled.span `
  border: 0;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
//# sourceMappingURL=Logo.styled.js.map